import { ReactNode } from "react";
import clsx from "clsx";
import hexToRgb from "@/core/helpers/hexToRgb";

type Props = {
  type?: "left" | "right";
  children: ReactNode;
  color: string;
};

export default function FactionTextWrapper({ type = "left", children, color }: Props) {
  const [r, g, b] = hexToRgb(color);

  return (
    <div
      className={clsx(
        "flex items-center gap-2 py-4 rounded-2xl",
        type === "left" ? "pl-4 pr-5" : "pl-5 pr-4",
      )}
      style={{
        background: `linear-gradient(${
          type === "left" ? "270" : "90"
        }deg, rgba(${r}, ${g}, ${b}, 0.00) 0%, rgba(${r}, ${g}, ${b}, 0.01) 35%, rgba(${r}, ${g}, ${b}, 0.13) 80.77%), #181818`,
        backgroundColor: "#181818",
      }}
    >
      {children}
    </div>
  );
}
